module.exports = __webpack_public_path__ + "static/media/instagram.41c578ad.webm";